import styled from 'styled-components';

export const StldCardOptions = styled.article `
    border: solid #E8E8E8 1px;
    border-radius: .25rem;
    padding: 1rem;
    margin: 1rem;
    background-color: #fff;
    height: fit-content;

    & .info-sections {
        width: 90%;
        --height: 75px;
        font-si
    }

    & .menu-sections {
        width: 10%;
    }
`